<template>
	<div class="xhdiv">
		<div class="flex flex-nowrap flex_row flex-vend fulldiv stilContext">
			<template v-for="item,index in QD">
				<span class="stil" :key="index" :style="item['fnumber']>=TQD&&TQD!=''?'background-color:#18ca57;':''"></span>
			</template>
			<p>
				{{QDName}}
			</p>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'vaildPass',
		props: {
			PASSCASE: {
				type: Object,
				default: () => {}
			},
			pass: {
				type: String,
				default: ''
			},
			old: {
				type: String,
				default: ''
			}
		},
		watch: {
			pass(NEW) {
				this.changeColor(NEW)
			},
			PASSCASE(NEW, OLD) {
				console.log(NEW, OLD)
				this.changeStil()
			}
		},
		data() {
			return {
				TQD: '',
				QDName: ''
			}
		},
		computed: {
			userinfo() {
				return this.$store.getters.UserInfo;
			},
			QD() {
				if (this.PASSCASE.QD) {
					let temp = this.PASSCASE.QD;
					let sortAftet = temp.sort(function(f, a) {
						let ff = f['fnumber'];
						let aa = a['fnumber'];
						return  aa-ff;
					});
					console.log(sortAftet)
					return sortAftet;
				}
				return [];

			},
			ColName() {
				return this.PASSCASE.ColName || [];
			},
			Rule() {
				return this.PASSCASE.Rule && this.PASSCASE.Rule[0] ? this.PASSCASE.Rule[0] : {};
			},
			stil() {
				return document.getElementsByClassName('stil');
			},
			CheckRule() {
				let FSpecical = this.Rule['FSpecical'] || '';
				FSpecical = `[${FSpecical}]`;
				return {
					FBLetter: /[A-Z]/g,
					FSLetter: /[a-z]/g,
					FNum:/[0-9]/g,
					FSpecicalNum: new RegExp(FSpecical, "g")
				}
			}
		},
		methods: {
			changeColor(NEW) {
				// console.log(NEW)
				if (NEW.length == 0) {
					this.TQD = '';
					this.QDName = '';
					return false;
				}
				var vailnum = 0;
				for (let i in this.ColName) {
					let ffield = this.ColName[i]['FField'];
					let value = this.Rule[ffield];
					if (this.CheckRule[ffield]) {
						let temppass = NEW.replace(this.CheckRule[ffield], '');
						let num = Math.abs(temppass.length - NEW.length);
						if (num >= Number(value)) {
							//条件满足
							vailnum += 1;
						}
					} else if (ffield == 'FISSame') {//不允许才算一个规则
						if(!value&&NEW != this.userinfo.pfnumber)
							vailnum += 1;
					} else if (ffield == 'FLength') {
						if (NEW.length >= Number(value)) vailnum += 1;
					}else if(ffield=='FSameLast'){
						if(!value&&this.old!=NEW) vailnum += 1;
					}else if(ffield=='FFirst'){
						if(!value&&'q1w2e3'!=NEW) vailnum += 1;
					}
				}
				let Len = this.QD.filter(item => {
					return vailnum >= item.FRuleNum;
				});
				// console.log(Len,vailnum,Number(this.Rule['FRuleNum']))
				if (Len.length > 0) {
					Len = Len.sort(function(f, a) {
						let ff = f['fnumber'];
						let aa = a['fnumber'];
						return  ff-aa;
					});
					this.TQD = Len[0].fnumber;
					this.QDName = Len[0].fname;
					if (Number(this.Rule['FRuleNum']) <= vailnum) {
						return true;
					} else {
						return false;
					}
				} else {
					this.TQD = '';
					this.QDName = ''
					return false;
				}
			},
			changeStil() {
				console.log('change')
				if (this.stil && this.stil.length > 0) {
					let _theight = 10;
					for (let i in this.QD) {
						let item = this.stil[i].style;
						item.setProperty('--stilcolor', '#909090');
						item.setProperty('--stilheight', `${_theight}px`);
						_theight += 5;
					}
				}
			}

		},
		mounted() {
			this.changeStil()
		}
	}
</script>

<style scoped>
	.xhdiv {
		width: 2.4rem;
		height: 1.7rem;
		/* width: 50px;
		height: 40px; */
		/* background-color: #909090; */
		margin: 0 5px;
	}

	.stilContext {}

	.stilContext p {}

	.stil {
		width: .3rem;
		background-color: var(--stilcolor);
		height: var(--stilheight);
		margin: 0 .1rem;
	}
	p{
		font-size: var(--font_small);
	}
</style>
